module.exports = __webpack_public_path__ + "fonts/bmjh.d19b6234.ttf";